<div class="loader" [ngClass]="('ajax-loader loadingCongif ' + (config.inline ? 'inline-loader' : '') )" *ngIf="canShow===true">
    <!-- <p> loaderId :: {{ loaderId }} :: {{canShow}} </p> -->

    <div *ngIf="requestStates.PROGRESS === currentState" class="loadingPosition">
        <p class="mar0 text-center">
            <span>
                <img src="../../../assets/images/Rolling.gif">
                <span class="inlineText">
                    {{config.progressText}}
                </span>
            </span>
        </p>
    </div>

    <div class="errorContainer" *ngIf="requestStates.ERROR === currentState || requestStates.CANCELED === currentState">
        <div class="closeItm cursor pull-right">
            <img src="../../../assets/images/icon-delete1.png" (click)="close($event)"> </div>
        <p class="pull-left mar0">
            <span>
                <img src="../../../assets/images/error_icon.png"> </span>
            <span [innerHtml]="errorText || statusMessage.error_msg || (config.errorText + ':' + loaderId)"></span>
        </p>
    </div>

    <div class="successContainer" *ngIf="requestStates.SUCCESS === currentState">
        <div class="closeItm cursor pull-right" *ngIf="oppShared === false">
            <img src="../../../assets/images/icon-delete1.png" (click)="close($event)"> </div>
        <p class="pull-left mar0">
            <span [innerHtml]="statusMessage"></span>
        </p>
        <div *ngIf="oppShared === true" class="okButton">
            <button class="btn btn-primary" (click)="close($event)">OK</button>
        </div>
    </div>


</div>